/* eslint-disable import/prefer-default-export */
import * as req from 'api/actions';
import * as c from './constant';

export const getHistoryList = (buildingId, payload, callback) =>
  req.list(
    c.GET_BUILDING_HISTORY_LIST,
    `api/v1/rpt/administrator/buildings/building_applications/${buildingId}/building_history_logs?isPaginate=1`,
    payload,
    callback
  );

export const getLandAppraisalList = (id, payload, callback) =>
  req.list(
    c.GET_LAND_APPRAISAL,
    `/api/v1/rpt/administrator/land/land_applications/${id}/land_appraisals`,
    payload,
    callback
  );

export const getSingleLandAppraisal = (id, landAppraisalId, payload, callback) =>
  req.item(
    c.GET_SINGLE_LAND_APPRAISAL,
    `/api/v1/rpt/administrator/land/land_applications/${id}/land_appraisals/${landAppraisalId}`,
    payload,
    callback
  );

export const createLandAppraisal = (id, payload, callback) =>
  req.create(
    c.CREATE_LAND_APPRAISAL,
    `/api/v1/rpt/administrator/land/land_applications/${id}/land_appraisals`,
    payload,
    ({ res }) => {
      const { data } = res.res;
      if (callback) callback({ data });
    }
  );

export const updateLandAppraisal = (id, landAppraisalId, payload, callback) =>
  req.update(
    c.UPDATE_LAND_APPRAISAL,
    `/api/v1/rpt/administrator/land/land_applications/${id}/land_appraisals/${landAppraisalId}`,
    payload,
    ({ res }) => {
      const { data } = res.res;
      if (callback) callback({ data });
    }
  );

export const removeLandAppraisal = (id, landAppraisalId, payload, callback) =>
  req.remove(
    c.REMOVE_LAND_APPRAISAL,
    `/api/v1/rpt/administrator/land/land_applications/${id}/land_appraisals/${landAppraisalId}`,
    payload,
    ({ res }) => {
      const { message } = res.res;
      alert.success(message || 'Successfully Removed !');
      if (callback) callback();
    }
  );

export const getLandPropertyAssessmentList = (id, payload, callback) =>
  req.list(
    c.GET_LAND_PROPERTY_ASSESSMENT,
    `/api/v1/rpt/administrator/land/land_applications/${id}/land_property_assessments`,
    payload,
    callback
  );

export const getSingleLandPropertyAssessment = (id, landPropertyAssessmentId, payload, callback) =>
  req.item(
    c.GET_SINGLE_LAND_PROPERTY_ASSESSMENT,
    `/api/v1/rpt/administrator/land/land_applications/${id}/land_property_assessments/${landPropertyAssessmentId}`,
    payload,
    callback
  );

export const createLandPropertyAssessment = (id, payload, callback) =>
  req.create(
    c.CREATE_LAND_PROPERTY_ASSESSMENT,
    `/api/v1/rpt/administrator/land/land_applications/${id}/land_property_assessments`,
    payload,
    ({ res }) => {
      const { data } = res.res;
      if (callback) callback({ data });
    }
  );

export const updateLandPropertyAssessment = (id, landPropertyAssessmentId, payload, callback) =>
  req.update(
    c.UPDATE_LAND_PROPERTY_ASSESSMENT,
    `/api/v1/rpt/administrator/land/land_applications/${id}/land_property_assessments/${landPropertyAssessmentId}`,
    payload,
    ({ res }) => {
      const { data } = res.res;
      if (callback) callback({ data });
    }
  );

export const removeLandPropertyAssessment = (id, landPropertyAssessmentId, payload, callback) =>
  req.remove(
    c.REMOVE_LAND_PROPERTY_ASSESSMENT,
    `/api/v1/rpt/administrator/land/land_applications/${id}/land_property_assessments/${landPropertyAssessmentId}`,
    payload,
    ({ res }) => {
      const { message } = res.res;
      alert.success(message || 'Successfully Removed !');
      if (callback) callback();
    }
  );

export const getLandMarketValueList = (id, payload, callback) =>
  req.list(
    c.GET_LAND_MARKET_VALUE,
    `/api/v1/rpt/administrator/land/land_applications/${id}/land_market_values`,
    payload,
    callback
  );

export const getSingleLandMarketValue = (id, landMarketValueId, payload, callback) =>
  req.item(
    c.GET_SINGLE_LAND_MARKET_VALUE,
    `/api/v1/rpt/administrator/land/land_applications/${id}/land_market_values/${landMarketValueId}`,
    payload,
    callback
  );

export const createLandMarketValue = (id, payload, callback) =>
  req.create(
    c.CREATE_LAND_MARKET_VALUE,
    `/api/v1/rpt/administrator/land/land_applications/${id}/land_market_values`,
    payload,
    ({ res }) => {
      const { data } = res.res;
      if (callback) callback({ data });
    }
  );

export const updateLandMarketValue = (id, landMarketValueId, payload, callback) =>
  req.update(
    c.UPDATE_LAND_MARKET_VALUE,
    `/api/v1/rpt/administrator/land/land_applications/${id}/land_market_values/${landMarketValueId}`,
    payload,
    ({ res }) => {
      const { data } = res.res;
      if (callback) callback({ data });
    }
  );

export const removeLandMarketValue = (id, landMarketValueId, payload, callback) =>
  req.remove(
    c.REMOVE_LAND_MARKET_VALUE,
    `/api/v1/rpt/administrator/land/land_applications/${id}/land_market_values/${landMarketValueId}`,
    payload,
    ({ res }) => {
      const { message } = res.res;
      alert.success(message || 'Successfully Removed !');
      if (callback) callback();
    }
  );

export const getLandClassificationsList = (payload, callback) =>
  req.list(
    c.GET_LAND_CLASSIFICATIONS,
    'api/v1/rpt/administrator/land/settings/land_classifications?isPaginate=1',
    payload,
    callback
  );

export const getSingleLandClass = (id, payload, callback) =>
  req.item(
    c.GET_SINGLE_LAND_CLASS,
    `api/v1/rpt/administrator/land/settings/land_classifications/${id}`,
    payload,
    callback
  );

export const getTransactionCodesList = (payload, callback) =>
  req.list(
    c.GET_TRANSACTION_CODES,
    'api/v1/rpt/administrator/settings/transaction_codes',
    payload,
    callback
  );

export const getProvinceList = (payload, callback) =>
  req.list(
    c.GET_PROVINCE,
    'api/v1/administrators/address/provinces',
    payload,
    callback
  );

export const getMunicipalityList = (payload, callback) =>
  req.list(
    c.GET_MUNICIPALITIES,
    'api/v1/administrators/address/municipalities',
    payload,
    callback
  );

export const getBarangayList = (payload, callback) =>
  req.list(
    c.GET_BARANGAYS,
    'api/v1/administrators/address/barangays',
    payload,
    callback
  );

export const getAdditionalItemLogs = (buildingId, payload, callback) =>
  req.list(
    c.GET_ADDITIONAL_ITEM_LOGS,
    `api/v1/rpt/administrator/buildings/building_history_logs/${buildingId}/building_additional_item_logs`,
    payload,
    callback
  );

export const showAdditionalItemLogs = (buildingId, id, payload, callback) =>
  req.item(
    c.SHOW_ADDITIONAL_ITEM_LOGS,
    `api/v1/rpt/administrator/buildings/building_history_logs/${buildingId}/building_additional_item_logs/${id}`,
    payload,
    callback
  );

export const getFloorPlanLogs = (buildingId, payload, callback) =>
  req.list(
    c.GET_FLOOR_PLAN_LOGS,
    `api/v1/rpt/administrator/buildings/building_history_logs/${buildingId}/building_floor_storey_area_logs`,
    payload,
    callback
  );

export const getPropertyAppraisalLogs = (buildingId, payload, callback) =>
  req.list(
    c.GET_PROPERTY_APPRAISAL_LOGS,
    `api/v1/rpt/administrator/buildings/building_history_logs/${buildingId}/building_property_appraisal_logs`,
    payload,
    callback
  );

export const showPropertyAppraisalLogs = (buildingId, id, payload, callback) =>
  req.list(
    c.SHOW_PROPERTY_APPRAISAL_LOGS,
    `api/v1/rpt/administrator/buildings/building_history_logs/${buildingId}/building_property_appraisal_logs/${id}`,
    payload,
    callback
  );

export const getPropertyAssessmentLogs = (id, payload, callback) =>
  req.list(
    c.GET_PROPERTY_ASSESSMENT_LOGS,
    `/api/v1/rpt/administrator/buildings/building_history_logs/${id}/building_property_assessment_logs`,
    payload,
    callback
  );

export const getStructuralMaterialsLogs = (id, payload, callback) =>
  req.list(
    c.GET_STRUCTURAL_MATERIAL_LOGS,
    `/api/v1/rpt/administrator/buildings/building_history_logs/${id}/building_structural_material_logs`,
    payload,
    callback
  );

export const getTransactionsLogs = (id, payload, callback) =>
  req.list(
    c.GET_TRANSACTIONS_LOGS,
    `/api/v1/rpt/administrator/buildings/building_history_logs/${id}/building_transaction_logs`,
    payload,
    callback
  );

export const getSupersededAssessmentLogs = (buildingId, payload, callback) =>
  req.list(
    c.GET_SUPERSEDED_ASSESSMENT_LOGS,
    `api/v1/rpt/administrator/buildings/building_history_logs/${buildingId}/building_sup_assessment_logs`,
    payload,
    callback
  );

export const showSupersededAssessmentLogs = (buildingId, id, payload, callback) =>
  req.item(
    c.SHOW_SUPERSED_ASSESSMENT_LOGS,
    `api/v1/rpt/administrator/buildings/building_history_logs/${buildingId}/building_sup_assessment_logs/${id}`,
    payload,
    callback
  );

export const getPropertyLocationLogs = (buildingId, id, payload, callback) =>
  req.item(
    c.GET_PROPERTY_LOCATION_LOGS,
    `api/v1/rpt/administrator/buildings/building_applications/${buildingId}/building_history_logs/${id}`,
    payload,
    callback
  );
